import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
	FaEnvelope,
	FaPhone,
	FaFacebook,
	FaTwitter,
	FaLinkedin,
	FaInstagram,
} from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
	return (
		<footer className="footer">
			<Container>
				<Row>
					<Col md={4} className="footer-section">
						<h4>Contact Us</h4>
						<p>
							<FaEnvelope /> Email: email@example.com
						</p>
						<p>
							<FaPhone /> Phone: +91 99999 99999
						</p>
					</Col>
					<Col md={4} className="footer-section">
						<h4>Quick Links</h4>
						<ul>
							<li>
								<a href="#home">Home</a>
							</li>
							<li>
								<a href="#about">About Us</a>
							</li>
							<li>
								<a href="#features">Features</a>
							</li>
							<li>
								<a href="#roadmap">Roadmap</a>
							</li>
							<li>
								<a href="#contact">Contact</a>
							</li>
						</ul>
					</Col>
					<Col md={4} className="footer-section">
						<h4>Follow Us</h4>
						<ul>
							<li>
								<a href="#">
									<FaFacebook /> Facebook
								</a>
							</li>
							<li>
								<a href="#">
									<FaTwitter /> Twitter
								</a>
							</li>
							<li>
								<a href="#">
									<FaLinkedin /> LinkedIn
								</a>
							</li>
							<li>
								<a href="#">
									<FaInstagram /> Instagram
								</a>
							</li>
						</ul>
					</Col>
				</Row>
				<Row>
					<Col>
						<p className="text-center footer-copyright">
							&copy; Learn Your Way. All rights
							reserved.
						</p>
					</Col>
				</Row>
			</Container>
		</footer>
	);
};

export default Footer;
